import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Buttons, ModalBase, Separators } from 'components';
import { manageCampaignsActions } from 'store/actions';
import * as S from './InvalidTrackingLinksModal.styled';

export const InvalidTrackingLinksModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const trackingModalUrl = useSelector((state) => state.manageCampaigns.trackingModalUrl);

  function handleCloseModal() {
    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'trackingModalUrl',
        newValue: null,
      }),
    );
  }

  function navigateToEdit() {
    navigate(trackingModalUrl);
    handleCloseModal();
  }

  return (
    <ModalBase>
      <S.Box>
        <S.Content>
          <S.ModalDeleteTitle>Invalid Tracking Links</S.ModalDeleteTitle>
          <S.ModalDeleteText>
            This campaign uses S2S tracking links that are not supported anymore.
            <br /> In order to resume your campaign, update the tracking links to use direct links
            from attributions companies.
          </S.ModalDeleteText>
        </S.Content>
        <S.NotificationIcon>!</S.NotificationIcon>
      </S.Box>
      <Separators type={Separators.separatorTypes.small} />
      <S.Footer>
        <Buttons.SecondaryNormal
          id='close-modal-btn'
          onClick={handleCloseModal}
          style={{ width: '100%' }}
        >
          Close
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='edit-modal-btn'
          onClick={navigateToEdit}
          style={{ width: '100%' }}
        >
          Edit Tracking Links
        </Buttons.PrimaryNormal>
      </S.Footer>
    </ModalBase>
  );
};
